import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pinv-range',
  templateUrl: './pinv-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PINVRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
